import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Users, MapPin, ChevronLeft, Building2, ShieldCheck, Mail, Phone, Globe, ExternalLink } from 'lucide-react';
import { AcShieldLogo } from '../../components/security/AcShieldLogo';

export function SobrePage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#F5F0E8', // var(--cream)
      color: '#4A4540', // var(--gray-700)
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 20px'
    }}>
      {/* Header com Logo e Voltar */}
      <div style={{
        width: '100%',
        maxWidth: '900px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px',
        borderBottom: '1px solid #E8E0D4', // var(--cream-dark)
        paddingBottom: '20px'
      }}>
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#1B365D', // var(--navy)
          textDecoration: 'none',
          fontSize: '0.9rem',
          fontWeight: 600,
          transition: 'color 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = '#2A4A7F'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#1B365D'}
        >
          <ChevronLeft size={18} />
          Voltar ao Início
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 28, height: 28, color: '#1B365D' }}>
            <AcShieldLogo style={{ width: '100%', height: '100%' }} />
          </div>
          <span style={{ fontSize: '1.2rem', fontWeight: 800, color: '#1B365D' }}>
            Aluno <strong style={{ color: '#B86B47' }}>Conectado</strong>
          </span>
        </div>
      </div>

      {/* Container Principal */}
      <main style={{
        width: '100%',
        maxWidth: '900px',
        background: '#FFFFFF', // var(--white)
        border: '1px solid #E8E0D4',
        borderRadius: '16px',
        boxShadow: '0 8px 30px rgba(27, 54, 93, 0.08)', // var(--shadow-md)
        overflow: 'hidden'
      }}>
        {/* Banner de Imagem Fixo */}
        <div style={{
          width: '100%',
          height: '240px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <img 
            src="/assets/images/hero.png" 
            alt="Escola Aluno Conectado" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover' 
            }} 
          />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(27, 54, 93, 0.92) 0%, rgba(27, 54, 93, 0.4) 100%)'
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '24px',
            left: '40px',
            color: '#fff'
          }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(8px)', padding: '6px 16px', borderRadius: '50px', marginBottom: '12px' }}>
              <Building2 size={14} style={{ color: '#fff' }} />
              <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#fff', letterSpacing: '1px', textTransform: 'uppercase' }}>Portal Corporativo</span>
            </div>
            <h1 style={{ fontSize: '2.2rem', fontWeight: 800, color: '#fff', margin: 0 }}>Sobre a Empresa & Projeto</h1>
          </div>
        </div>

        <div style={{ padding: '40px' }}>
          <p style={{ fontSize: '1rem', lineHeight: '1.6', color: '#4A4540', margin: '0 0 24px 0' }}>
            Transparência institucional, governança corporativa e informações oficiais da plataforma digital Aluno Conectado.
          </p>

        {/* Descrição do Negócio */}
        <section style={{ marginBottom: '36px', borderBottom: '1px solid #F0EDE5', paddingBottom: '32px' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1B365D', margin: '0 0 16px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ShieldCheck size={20} style={{ color: '#8BA888' }} />
            A Plataforma Aluno Conectado
          </h2>
          <p style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#4A4540', marginBottom: '16px' }}>
            O <strong>Aluno Conectado</strong> é uma plataforma de tecnologia educacional transacional dedicada à segurança, gestão e comunicação entre redes de ensino, professores, alunos e pais ou responsáveis. A plataforma atua de forma integrada, notificando instantaneamente a frequência escolar, eventos de controle de entrada e saída de alunos por RFID, boletins, diários de classe e avisos pedagógicos emergenciais.
          </p>
          <p style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#4A4540', margin: 0 }}>
            Nossos envios de e-mail e notificações são <strong>estritamente transacionais</strong> e automatizados. Não realizamos campanhas publicitárias, newsletters, e-mails de marketing ou promoções. O canal SMTP é dedicado unicamente a garantir a segurança e o fluxo informacional dos dados dos alunos para com seus responsáveis cadastrados.
          </p>
        </section>

        {/* Grid de Informações Corporativas */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginBottom: '40px' }}>
          {/* Coluna 1: Dados Jurídicos */}
          <div style={{ background: '#FAFAF8', borderRadius: '12px', padding: '24px', border: '1px solid #F0EDE5' }}>
            <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1B365D', margin: '0 0 16px 0', borderBottom: '1px solid #E8E0D4', paddingBottom: '8px' }}>
              Dados Jurídicos
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px', fontSize: '0.88rem' }}>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#8A8478', fontWeight: 600, width: '90px', flexShrink: 0 }}>Razão Social:</span>
                <span style={{ color: '#1A1815' }}>AC3 Soluções Tecnológicas Ltda.</span>
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#8A8478', fontWeight: 600, width: '90px', flexShrink: 0 }}>CNPJ:</span>
                <span style={{ color: '#1A1815', fontWeight: 600 }}>18.809.453/0001-29</span>
              </li>
              <li style={{ display: 'flex', gap: '8px' }}>
                <span style={{ color: '#8A8478', fontWeight: 600, width: '90px', flexShrink: 0 }}>E-mail:</span>
                <a href="mailto:contato@alunoconectado.com.br" style={{ color: '#B86B47', textDecoration: 'none', fontWeight: 600 }}>
                  contato@alunoconectado.com.br
                </a>
              </li>
              <li style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <MapPin size={16} style={{ color: '#8A8478', flexShrink: 0, marginTop: '3px' }} />
                  <span style={{ color: '#4A4540' }}>
                    <strong>Endereço Cadastral:</strong><br />
                    Avenida Portugal, 4340, Sala 101, Jardim Atlântico<br />
                    Belo Horizonte - MG, CEP 31710-434
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
                  <MapPin size={16} style={{ color: '#8A8478', flexShrink: 0, marginTop: '3px' }} />
                  <span style={{ color: '#4A4540' }}>
                    <strong>Endereço Operacional:</strong><br />
                    Rua Major Lopes, 190, São Pedro<br />
                    Belo Horizonte - MG, CEP 30330-050
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Coluna 2: Equipe de Gestão & Responsáveis */}
          <div style={{ background: '#FAFAF8', borderRadius: '12px', padding: '24px', border: '1px solid #F0EDE5' }}>
            <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1B365D', margin: '0 0 16px 0', borderBottom: '1px solid #E8E0D4', paddingBottom: '8px' }}>
              Responsáveis Declarados
            </h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '0.88rem' }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <Users size={16} style={{ color: '#B86B47', marginTop: '2px', flexShrink: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, color: '#1A1815' }}>Lucas Silveira Mourão</div>
                  <div style={{ fontSize: '0.78rem', color: '#8A8478' }}>CEO, Diretor Executivo e representante legal da sócia M5 Participações Ltda.</div>
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <Users size={16} style={{ color: '#B86B47', marginTop: '2px', flexShrink: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, color: '#1A1815' }}>Marcelo Duretti</div>
                  <div style={{ fontSize: '0.78rem', color: '#8A8478' }}>Sócio e Diretor de Tecnologia (TI)</div>
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <Users size={16} style={{ color: '#B86B47', marginTop: '2px', flexShrink: 0 }} />
                <div>
                  <div style={{ fontWeight: 700, color: '#1A1815' }}>Thiago Silva Ferreira</div>
                  <div style={{ fontSize: '0.78rem', color: '#8A8478' }}>Sócio-Administrador e Diretor de Relações Institucionais</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Quadro Societário & Liderança Executiva */}
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1B365D', margin: '0 0 20px 0', borderBottom: '1px solid #E8E0D4', paddingBottom: '8px' }}>
            Liderança Executiva
          </h2>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/* Lucas Mourão */}
            <div style={{ 
              background: '#FAFAF8', 
              border: '1px solid #F0EDE5', 
              borderRadius: '12px', 
              padding: '24px', 
              display: 'flex',
              gap: '24px',
              alignItems: 'flex-start'
            }}>
              <img 
                src="/assets/lucas-mourao.jpg" 
                alt="Lucas Mourão" 
                style={{ 
                  width: '100px', 
                  height: '100px', 
                  borderRadius: '50%', 
                  objectFit: 'cover',
                  border: '3px solid #E8E0D4',
                  flexShrink: 0
                }} 
              />
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: '#1B365D', margin: '0 0 4px 0' }}>
                  Lucas Silveira Mourão
                </h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.8rem', fontWeight: 700, color: '#B86B47', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '8px' }}>
                  <span>CEO & Diretor Executivo</span>
                  <span>•</span>
                  <span style={{ color: '#8A8478' }}>Representante da M5 Participações Ltda.</span>
                </div>
                
                <p style={{ fontSize: '0.88rem', lineHeight: '1.6', color: '#4A4540', margin: '0 0 16px 0' }}>
                  Responsável pela estratégia corporativa, pelo desenvolvimento comercial e pela expansão institucional do Aluno Conectado, representando a liderança corporativa ativa do portal.
                </p>

                {/* Redes Sociais */}
                <div style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                  <a 
                    href="https://www.linkedin.com/in/lucas-silveira-mourao-a21309b9" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', fontWeight: 600, color: '#1B365D', textDecoration: 'none' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#2A4A7F'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#1B365D'}
                  >
                    <ExternalLink size={14} />
                    LinkedIn
                  </a>
                  <a 
                    href="https://www.instagram.com/lucas_silveira_mourao/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.8rem', fontWeight: 600, color: '#1B365D', textDecoration: 'none' }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#2A4A7F'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#1B365D'}
                  >
                    <ExternalLink size={14} />
                    Instagram
                  </a>
                </div>
              </div>
            </div>

            {/* Marcelo Duretti */}
            <div style={{ 
              background: '#FAFAF8', 
              border: '1px solid #F0EDE5', 
              borderRadius: '12px', 
              padding: '24px', 
              display: 'flex',
              gap: '24px',
              alignItems: 'center'
            }}>
              <img 
                src="/assets/marcelo-duretti.jpg" 
                alt="Marcelo Duretti" 
                style={{ 
                  width: '100px', 
                  height: '100px', 
                  borderRadius: '50%', 
                  objectFit: 'cover',
                  border: '3px solid #E8E0D4',
                  flexShrink: 0
                }} 
              />
              <div>
                <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: '#1B365D', margin: '0 0 4px 0' }}>
                  Marcelo Duretti
                </h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.8rem', fontWeight: 700, color: '#B86B47', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <span>Sócio e Diretor de Tecnologia (TI)</span>
                </div>
                <p style={{ fontSize: '0.88rem', lineHeight: '1.6', color: '#4A4540', margin: '8px 0 0 0' }}>
                  Responsável pela arquitetura de sistemas do Aluno Conectado, liderando a infraestrutura de servidores, a segurança da informação, a integração com dispositivos RFID e a conformidade com a LGPD.
                </p>
              </div>
            </div>

            {/* Thiago Silva Ferreira */}
            <div style={{ 
              background: '#FAFAF8', 
              border: '1px solid #F0EDE5', 
              borderRadius: '12px', 
              padding: '24px', 
              display: 'flex',
              gap: '24px',
              alignItems: 'center'
            }}>
              <img 
                src="/assets/thiago-marcelo.jpg" 
                alt="Thiago Silva Ferreira" 
                style={{ 
                  width: '100px', 
                  height: '100px', 
                  borderRadius: '50%', 
                  objectFit: 'cover',
                  border: '3px solid #E8E0D4',
                  flexShrink: 0
                }} 
              />
              <div>
                <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: '#1B365D', margin: '0 0 4px 0' }}>
                  Thiago Silva Ferreira
                </h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.8rem', fontWeight: 700, color: '#B86B47', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <span>Sócio-Administrador e Diretor de Relações Institucionais</span>
                </div>
                <p style={{ fontSize: '0.88rem', lineHeight: '1.6', color: '#4A4540', margin: '8px 0 0 0' }}>
                  Responsável pelas parcerias institucionais, conformidade regulatória junto às secretarias de educação e governança de comunicação transacional de e-mails/SMS da plataforma.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Assessoria & Governança Societária */}
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1B365D', margin: '0 0 20px 0', borderBottom: '1px solid #E8E0D4', paddingBottom: '8px' }}>
            Assessoria & Governança Societária
          </h2>
          <div style={{ background: '#FAFAF8', border: '1px solid #F0EDE5', borderRadius: '12px', padding: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '12px' }}>
              <Globe size={16} style={{ color: '#B86B47', marginTop: '2px', flexShrink: 0 }} />
              <span>
                <strong>Mourão & Lamounier:</strong> <a href="https://mouraolamounier.com.br" target="_blank" rel="noopener noreferrer" style={{ color: '#B86B47', textDecoration: 'none', fontWeight: 600 }}>mouraolamounier.com.br</a> — Núcleo de Soluções Empresariais especializado em assessoria jurídica, contabilidade corporativa e estruturação societária para o projeto Aluno Conectado.
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '0.85rem', color: '#4A4540', paddingLeft: '24px' }}>
              <div><strong>Endereço Profissional:</strong> Alameda das Falcatas, 203, São Luiz, Belo Horizonte - MG, CEP 31275-070</div>
              <div><strong>E-mail de Contato:</strong> contato@mouraolamounier.com.br</div>
              <div><strong>Telefone:</strong> (31) 3274-9340</div>
            </div>
          </div>
        </section>
        </div>
      </main>

      {/* Footer Mínimo */}
      <footer style={{ 
        marginTop: '40px', 
        fontSize: '0.8rem', 
        color: '#8A8478', 
        textAlign: 'center', 
        lineHeight: '1.8',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Início</Link>
          <span>•</span>
          <Link to="/sobre" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Sobre Nós</Link>
          <span>•</span>
          <Link to="/politica-de-privacidade" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Política de Privacidade</Link>
          <span>•</span>
          <Link to="/cancelar-email" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Cancelar Recebimento</Link>
        </div>
        <div>
          <span>Avenida Portugal, 4340, Sala 101, Jardim Atlântico, Belo Horizonte - MG, CEP 31710-434</span>
          <span style={{ margin: '0 8px' }}>|</span>
          <span>Contato: (31) 3274-9340 | contato@alunoconectado.com.br</span>
        </div>
        <p style={{ margin: 0 }}>&copy; 2026 Aluno Conectado. Desenvolvido por AC3 Soluções Tecnológicas Ltda.</p>
      </footer>
    </div>
  );
}
